<template lang="pug">
	v-card#formcadastrocliente(ref='form')
		v-card-text
			h1.red--text.title Dados da empresa
			v-layout(justify-space-between='' row='' wrap='')
				v-flex(md5='')
					v-text-field(ref='nome' v-model='cliente.nome' :rules="[() => !!cliente.nome || 'Este campo é obrigatório']" label='Nome da empresa' placeholder='Nome da empresa' required='')
				v-flex(md5='')
					v-text-field(ref='nomefantasia' :rules="[() => !!cliente.nomefantasia || 'Este campo é obrigatório', () => !!cliente.nomefantasia]" v-model='cliente.nomefantasia' label='Nome Fantasia' placeholder='Nome Fantasia' required='')
			v-layout(justify-space-between='' row='' wrap='')
				v-flex(md5='')
					v-text-field(ref='cnpj' :rules="[() => !!cliente.cnpj || 'Este campo é obrigatório']" v-model='cliente.cnpj' label='Cnpj' placeholder='Cnpj' required='')
				v-flex(md5='')
					v-text-field(ref='email' :rules="[() => /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(cliente.email) || 'Informe um e-mail válido']" v-model='cliente.email' label='E-mail' required='' placeholder='E-mail')
			v-text-field(ref='telefonesadd' label='Informe o telefone e pressione enter' placeholder='Telefone' v-model='tempfone' @keyup.enter="cliente.telefones.push(tempfone), tempfone=''" color='blue-grey')
			v-chip(:key='i' v-for='(t, i) in cliente.telefones')
				| {{ t }}
				v-icon(@click='cliente.telefones.splice(i, 1)' right='') clear
			h1.red--text.title Endere&ccedil;o
			v-layout(justify-space-between='' row='' wrap='')
				v-flex(md5='')
					v-text-field(ref='logradouro' :rules="[() => !!cliente.endereco.logradouro || 'Este campo é obrigatório']" v-model='cliente.endereco.logradouro' label='Logradouro' placeholder='Logradouro' required='' color='blue-grey')
				v-flex(md5='')
					v-text-field(ref='numero' :rules="[() => !!cliente.endereco.numero || 'Este campo é obrigatório']" v-model='cliente.endereco.numero' label='número' placeholder='número' required='' color='blue-grey')
			v-layout(justify-space-between='' row='' wrap='')
				v-flex(md5='')
					v-text-field(ref='bairro' :rules="[() => !!cliente.endereco.bairro || 'Este campo é obrigatório']" v-model='cliente.endereco.bairro' label='bairro' placeholder='bairro' required='' color='blue-grey')
				v-flex(md5='')
					v-text-field(ref='cidade' :rules="[() => !!cliente.endereco.cidade || 'Este campo é obrigatório']" v-model='cliente.endereco.cidade' label='cidade' placeholder='cidade' required='' color='blue-grey')
			v-layout(justify-space-between='' row='' wrap='')
				v-flex(md5='')
					v-text-field(ref='estado' :rules="[() => !!cliente.endereco.estado || 'Este campo é obrigatório']" v-model='cliente.endereco.estado' label='estado' placeholder='estado' required='' color='blue-grey')
				v-flex(md5='')
					v-text-field(@keypress="formatar('#####-###', $event)" ref='cep Ex: #####-###' :rules="[() => /^[0-9]{5}-[0-9]{3}$/.test(this.cliente.endereco.cep) || 'Informe um cep válido' ]" v-model='cliente.endereco.cep' label='cep' placeholder='Ex: #####-###' required='' @keyup='getCep' color='blue-grey')
			v-divider.mt-5
			v-card-actions
				v-spacer
				v-btn.white--text(color='red darken-2' :disabled='!validate' @click='cadastrar' dark) Enviar

</template>


<script>
import axios from 'axios'
import Mask from '../../helpers/Mask'
import getCep from '../../helpers/GetCep'
import {mapActions} from 'vuex'

export default {
  mixins:[Mask],
  data(){
    return{
      tempfone:'',
      cliente:{
        nome:'',
        nomefantasia:'',
        cnpj:'',
        telefones:[],
        email:'',
        endereco:{
          logradouro:'',
          numero:'',
          bairro:'',
          cidade:'',
          estado:'',
          cep:''
        }
      }
    }
  },
  methods:{
    ...mapActions(['empresas_saveEmpresa']),
    getCep()
    {
      if(/^[0-9]{5}-[0-9]{3}$/.test(this.cliente.endereco.cep))
      {
        getCep(this.cliente.endereco.cep).then(r => {
          let {logradouro, bairro, localidade, uf } = r
          this.cliente.endereco.logradouro = logradouro
          this.cliente.endereco.bairro     = bairro
          this.cliente.endereco.cidade     = localidade
          this.cliente.endereco.estado     = uf
        })
      }
    },
    cadastrar()
    {
      this.empresas_saveEmpresa(this.cliente).then(r=>{
					if(r.status)this.$eventHub.emit('snackBar', r.message)
					else this.$eventHub.emit('snackBar', "Não foi possivel cadastrar")
      })
    }
  },
  computed:{
    validate()
    {
      return !!(
        this.cliente.nome && this.cliente.nomefantasia && this.cliente.cnpj &&
        /^[a-z0-9._]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(this.cliente.email) &&
        this.cliente.endereco.logradouro && this.cliente.endereco.numero && this.cliente.endereco.bairro &&
        this.cliente.endereco.cidade && this.cliente.endereco.estado && this.cliente.endereco.cep
      )
    }
  }
}
</script>

<style scoped lang="stylus">
#formcadastrocliente
	padding-right 100px
	padding-left 100px

.title
	margin-top 40px
	margin-bottom 40px

</style>





// WEBPACK FOOTER //
// src/components/root/CadastrarCliente.vue